module.exports = __webpack_public_path__ + "img/treasure.022858d5.png";